<template>
  <a-modal
    :visible="localVisible"
    :title="$t('平台退款单')"
    :width="800"
    :footer="null"
    @cancel="onCancel"
  >
    <a-table
      :columns="columns"
      :dataSource="orders"
      :pagination="false"
      bordered
      size="middle"
      rowKey="platformRefundOrderId"
      :scroll="{ x: 700 }"
    />
  </a-modal>
</template>

<script>
import { toThousands } from '@/common/filters'

export default {
  name: 'PlatformRefundRecordModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localVisible: this.visible,
      statusList: ['SUBMITTING', 'UNKNOWN', 'WAIT_PLATFORM_RESULT', 'SUCCESS', 'CLOSED', 'FAILED'],
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('平台退款单号'),
          dataIndex: 'platformRefundOrderSn',
          width: 190,
        },
        {
          title: this.$t('退款状态'),
          dataIndex: 'status',
          width: 120,
          customRender: (text) => this.formatStatus(text),
        },
        {
          title: this.$t('平台状态'),
          dataIndex: 'platformStatusLabel',
          width: 140,
          customRender: (text, record) => record.platformStatusLabel || '-',
        },
        {
          title: this.$t('申请金额'),
          dataIndex: 'requestedAmount',
          width: 120,
          customRender: (text) => this.formatAmount(text),
        },
        {
          title: this.$t('已退款金额'),
          dataIndex: 'refundedAmount',
          width: 120,
          customRender: (text) => this.formatAmount(text),
        },
      ]
    },
  },
  watch: {
    visible(val) {
      this.localVisible = val
    },
    localVisible(val) {
      this.$emit('update:visible', val)
    },
  },
  methods: {
    formatAmount(value) {
      if (value === undefined || value === null || value === '') return '-'
      return toThousands(value)
    },
    formatStatus(status) {
      if (!status) return '-'
      return this.statusList.includes(status) ? this.$t('form.' + status) : status
    },
    onCancel() {
      this.localVisible = false
    },
  },
}
</script>
